import { StaticImage } from '@/common/constants/displateRoutes';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

/**
 * @returns '/lumino'
 */
export const RouteToAllLuminosPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: `/lumino`, target: 'elysium' });
};

export const AllLuminosPageConfig: PageConfig = {
  readableName: 'All luminos',
  analyticsGaName: 'all-luminos',
  analyticsAthenaName: 'all-luminos',
  pagePathnames: ['/lumino'],
  displayPromoBar: false,
  defaultMeta: {
    title: `Lumino Posters | Displate`,
    description: `Turn on the magic with Displate Lumino, a limited series of next-gen illuminated art! The most awesome way to light up your walls.`,
    coverImage: StaticImage('/images/lumino/social/social_lumino.webp'),
  },
};
